<template>
    <Modal
        size="lg"
        :title="$t('targets.linkToTags')"
        :okTitle="$t('modal.save')"
        :okDisabled="disabledOkButton"
        :cancelDisabled="disabledCancelButton"
        :cancelTitle="$t('modal.cancel')"
        :noCloseOnEsc="true"
        :noCloseOnBackdrop="true"
        isModalRoute
        @okHandler="onSubmit"
    >
        <Loader :loader="isModalLoading" />
        <div v-show="!isModalLoading">
            <Tags
                :state="checkState('tags')"
                :value.sync="$v.form.tags.$model"
                @ready="tagsReady = $event"
            />
        </div>
        <template slot="okButton">
            <i v-if="isSubmitting" class="fa fa-spinner fa-spin px-2"></i>
        </template>
    </Modal>
</template>

<script>
import api from '@/services/api'
import { getParam as getUrlParam } from '@/lib/url'
import notification, { success, danger } from '@/lib/notification'
import i18n from '@/i18n'
import Modal from '@/views/components/modal'
import { Tags } from '@/views/components/fields'
import { validationMixin } from 'vuelidate'
import { required, integer } from 'vuelidate/lib/validators'
import Loader from '@/views/components/loader'
import { mapperToOptions } from '@/views/components/selects'

notification.init()

export default {
    name: 'LinkTags',
    components: {
        Modal,
        Tags,
        Loader,
    },
    mixins: [validationMixin],
    props: ['data'],
    data() {
        return {
            targetId: getUrlParam('targetId', this),
            loader: true,
            tagsReady: false,
            isSubmitting: false,
            form: {
                tags: [],
            },
        }
    },
    methods: {
        checkState(val) {
            const field = this.$v.form[val] || val
            return !field.$dirty || !field.$invalid
        },
        onSubmit(event, closeModal) {
            event.preventDefault()
            this.isSubmitting = true
            api.put(`/goals/${this.targetId}/update-tags `, {
                tags: this.mapperTagsToAPI(),
            })
                .then(resp => {
                    const {
                        data: { data },
                    } = resp
                    this.$emit('update-parent', 'updateTags', data.tags)
                    this.notificationEditedSuccessfully()
                })
                .catch(error => {
                    console.log(error)
                    this.notificationError()
                })
                .finally(() => {
                    this.isSubmitting = false
                    closeModal()
                })
        },
        mapperTagsToAPI() {
            const tags = this.form.tags
            return tags.map(tag => ({
                tag_id: this.getValue(tag),
            }))
        },
        getValue(object, property = 'value') {
            return object ? object[property] : null
        },
        notificationEditedSuccessfully() {
            success(
                i18n.t('notification.editedSuccessfully', {
                    item: i18n.t('targets.target'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
    computed: {
        isModalLoading() {
            return !this.tagsReady
        },
        disabledOkButton() {
            return this.isModalLoading || this.isSubmitting
        },
        disabledCancelButton() {
            return this.isSubmitting
        },
    },
    watch: {
        tagsReady() {
            this.form.tags = mapperToOptions(this.data.tags)
        },
    },
    validations: {
        form: {
            tags: {
                $each: {
                    value: {
                        integer,
                        required,
                    },
                    label: {
                        required,
                    },
                },
            },
        },
    },
}
</script>
